<!-- Left Sidebar -->
<aside
  id="leftsidebar"
  class="sidebar"
  (mouseenter)="mouseHover($event)"  
  (mouseleave)="mouseOut($event)"
>
    <!-- Sidebar Header -->
    <div class="sidebar-header">
      <img [src]="churchLogo" alt="Logo" [class.caritas-logo]="isCaritasLogo()"/>
    </div>

    <!-- Sidebar Menu -->
    <div class="menu">
      <ul class="list">
        <ng-container *ngFor="let sidebarItem of sidebarItems">
          <li
            [class.active]="level1Menu === menuId(sidebarItem)"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            *ngIf="!sidebarItem.hidden"
          >
          <div class="header" *ngIf="sidebarItem.groupTitle === true">
            {{ sidebarItem.title | translate }}
          </div>

          <a
            [routerLink]="sidebarItem.submenu.length === 0 ? [sidebarItem.path] : null"
            *ngIf="!sidebarItem.groupTitle"
            [ngClass]="[sidebarItem.class]"
            (click)="callLevel1Toggle($event, menuId(sidebarItem))"
            [attr.aria-expanded]="sidebarItem.submenu.length ? level1Menu === menuId(sidebarItem) : null"
            class="menu-top test-font"
          >
            <i-feather [name]="sidebarItem.icon" class="sidebarIcon"></i-feather>
            <span class="hide-menu">{{ sidebarItem.title }}</span>
            <!-- <span *ngIf="sidebarItem.badge" [ngClass]="[sidebarItem.badgeClass]">
              {{ sidebarItem.badge }}
            </span> -->
            <!-- <span *ngIf="sidebarItem.submenu.length > 0" class="arrow">►</span> -->
          </a>

          <ul class="ml-menu" *ngIf="sidebarItem.submenu.length > 0 && level1Menu === menuId(sidebarItem)">
            <ng-container *ngFor="let sidebarSubItem of sidebarItem.submenu">
              <li
                [ngClass]="level2Menu === menuId(sidebarSubItem) ? 'active' : ''"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                *ngIf="!sidebarSubItem.hidden"
              >
              <a
                [routerLink]="sidebarSubItem.submenu.length > 0 ? null : [sidebarSubItem.path]"
                (click)="callLevel2Toggle($event, menuId(sidebarSubItem))"
                [attr.aria-expanded]="sidebarSubItem.submenu.length ? level2Menu === menuId(sidebarSubItem) : null"
                [ngClass]="[sidebarSubItem.class]"
                class="test-font"
              >
                {{ sidebarSubItem.title | translate }}
              </a>

              <ul class="ml-menu-2" *ngIf="sidebarSubItem.submenu.length > 0 && level2Menu === menuId(sidebarSubItem)">
                <li
                  *ngFor="let sidebarSubsubItem of sidebarSubItem.submenu"
                  [ngClass]="level3Menu === menuId(sidebarSubsubItem) ? 'activeSubSub' : ''"
                  [routerLinkActive]="sidebarSubsubItem.submenu.length > 0 ? '' : 'active'"
                >
                  <a
                    [routerLink]="sidebarSubsubItem.submenu.length > 0 ? null : [sidebarSubsubItem.path]"
                    (click)="callLevel3Toggle($event, menuId(sidebarSubsubItem))"
                    [ngClass]="[sidebarSubsubItem.class]"
                    class="test-font"
                  >
                    {{ sidebarSubsubItem.title | translate }}
                  </a>
                </li>
              </ul>
              </li>
            </ng-container>
          </ul>
          </li>
        </ng-container>
      </ul>
    </div>

  <!-- Sidebar Footer -->
  <div class="sidebar-footer">
    <a (click)="logout()" class="logout-button">
      <i-feather name="log-out"></i-feather>
      <span>Logout</span>
    </a>
  </div>
</aside>
